import { cacheKey, prefetch } from "@/lib/dataCache";
import { api } from "@/lib/api";
import { normalizeProductList } from "@/lib/apiHelpers";
import { prefetchProductImages } from "@/lib/images";

const CATEGORY_SLUGS = ["ethnic", "coords", "dresses", "tops"];

const loadCategoryProducts = (slug, sort) =>
  api.get("/products", { params: { category: slug, sort } }).then((r) => {
    const items = normalizeProductList(r.data);
    prefetchProductImages(items);
    return items;
  });

export function prefetchCategories() {
  const key = cacheKey(["categories"]);
  prefetch(key, () => api.get("/categories").then((r) => (Array.isArray(r.data) ? r.data : [])));
}

export function prefetchCategoryProducts(slug, sort = "newest") {
  if (!slug) return;
  const key = cacheKey(["products", { slug, q: "", sort }]);
  prefetch(key, () => loadCategoryProducts(slug, sort));
}

export function prefetchAllCategories() {
  prefetchCategories();
  CATEGORY_SLUGS.forEach((slug) => prefetchCategoryProducts(slug));
}

export function prefetchAllCategoriesOnIdle() {
  let done = false;
  const run = () => {
    if (done) return;
    done = true;
    prefetchAllCategories();
  };
  // Warm all category lists quickly so tab clicks render from cache instantly.
  if (typeof window !== "undefined" && "requestIdleCallback" in window) {
    window.requestIdleCallback(run, { timeout: 800 });
  } else {
    setTimeout(run, 200);
  }
  // Fallback: first touch/hover anywhere warms the cache before any tab click lands.
  if (typeof window !== "undefined") {
    window.addEventListener("pointerdown", run, { once: true, passive: true });
    window.addEventListener("pointermove", run, { once: true, passive: true });
    window.addEventListener("touchstart", run, { once: true, passive: true });
  }
}
